import seedrandom from 'seedrandom';

export function getColor(seed) {
  const rng = seedrandom(seed);
  let mix = [0x16, 0xAC, 0xF9];
  let [red, green, blue] = new Array(3).fill(null).map(() => Math.floor(rng() * 256));

  return `rgb(${Math.floor((red + mix[0]) / 2)}, ${Math.floor((green + mix[1]) / 2)}, ${Math.floor((blue + mix[2]) / 2)})`;
}

export function isValidCssColor(color) {
  return color.match(/^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/);
}
